import React from "react";
import pic from "../assets/pharmacist.jpg";
import { useContext } from "react";
import { LanguageContext } from "../App";
const ContactUsIntro = () => {
  const { languageContext } = useContext(LanguageContext);
  return (
    <div className="mx-auto flex flex-col items-center px-4 lg:max-w-[45rem] xl:max-w-[55rem] 2xl:max-w-[75rem]">
      <div className=" lg  flex flex-col pt-24 text-center md:pt-32 lg:pt-28 xl:pt-32 2xl:pt-44">
        <div className="xl-gap-7 flex flex-col justify-between gap-10 md:gap-12 lg:flex-row lg:gap-24">
          <div className="flex flex-col gap-5 lg:text-start">
            <h6 className="text-[#00378A]">
              {languageContext === "english" ? <>Get in Touch</> : <>Liên Hệ</>}
            </h6>
            <h1>
              {languageContext === "english" ? (
                <>Ask Us Anything</>
              ) : (
                <>Hỏi Chúng Tôi</>
              )}
            </h1>
          </div>
          <div className="flex items-end lg:w-[46%] xl:w-[43%] 2xl:w-[33%]">
            <h6 className=" text-[#838B93] lg:text-end">
              {languageContext === "english" ? (
                <>
                  Have questions or need assistance? We're here to help. Reach
                  out to us through our contact form, email, or phone. Our team
                  is ready to provide the support you need.
                </>
              ) : (
                <>
                  Có câu hỏi hoặc cần hỗ trợ? Chúng tôi luôn sẵn sàng giúp đỡ.
                  Liên hệ với chúng tôi qua biểu mẫu liên hệ, email, hoặc điện
                  thoại. Đội ngũ của chúng tôi luôn sẵn sàng cung cấp sự hỗ trợ
                  bạn cần.
                </>
              )}
            </h6>
          </div>
        </div>
      </div>
      <img
        src={pic}
        className="standard-mt h-[25rem] w-full rounded-xl object-cover sm:h-[19rem]  md:h-[32.5rem] lg:h-[16rem] xl:h-[18rem] 2xl:h-[25rem]"
      />
    </div>
  );
};

export default ContactUsIntro;
